import './ButtonAnimatedUnderline.scss';
class ButtonAnimatedUnderline {
    constructor( node ) {
        this.node = node;
        this.timeout = null;
        this.timeout2 = null;
        this.state = null;
    }
    init() {
        let t = this;

        t.node.addEventListener('mouseenter', () => {
            clearTimeout( t.timeout2 );
            t.state = 'in';
            t.node.setAttribute( 'data-state' , 'animate-'+t.state );
            t.node.setAttribute( 'data-animate', 'true' );
            t.checkState();
        });
        t.node.addEventListener('mouseleave', () => {
            t.state = 'out';
            if( t.timeout == null ) {
                t.node.setAttribute('data-state','animate-out');
                t.timeout2 = setTimeout( () => {
                    t.node.removeAttribute( 'data-state' );
                    t.node.removeAttribute( 'data-animate' );
                }, 400 );
            }
        });

    }
    checkState() {
        let t = this;
        clearTimeout( t.timeout );
        t.timeout = setTimeout( () => {
            if( t.state == 'out' ) {
                t.node.setAttribute('data-state','animate-out');
                t.timeout2 = setTimeout( () => {
                    t.node.removeAttribute( 'data-state' );
                    t.node.removeAttribute( 'data-animate' );
                }, 400 );
            }
            clearTimeout( t.timeout );
            t.timeout = null;
        }, 400 );
    }
}
JSModules['ButtonAnimatedUnderline'] = ButtonAnimatedUnderline;
export default ButtonAnimatedUnderline;